import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { SummaryModalProps, TypedModalProps } from "components/modal";

export type ModalConfig = Omit<TypedModalProps, "show" | "handleCloseModal">;
export type SummaryModalConfig = Omit<
  SummaryModalProps,
  "show" | "handleCloseModal"
>;

export type ModalReducerState = {
  successConfig?: ModalConfig;
  errorConfig?: ModalConfig;
  summaryConfig?: SummaryModalConfig;
};

const initialState: ModalReducerState = {};

export const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    showSuccessModal: (state, action: PayloadAction<ModalConfig>) => {
      state.successConfig = action.payload;
    },
    showErrorModal: (state, action: PayloadAction<ModalConfig>) => {
      state.errorConfig = action.payload;
    },
    showSummaryModal: (state, action: PayloadAction<SummaryModalConfig>) => {
      state.summaryConfig = action.payload;
    },
    dismissSuccessModal: (state) => {
      state.successConfig = undefined;
    },
    dismissErrorModal: (state) => {
      state.errorConfig = undefined;
    },
    dismissSummaryModal: (state) => {
      state.summaryConfig = undefined;
    },
  },
});

export const {
  showSuccessModal,
  showErrorModal,
  showSummaryModal,
  dismissSuccessModal,
  dismissErrorModal,
  dismissSummaryModal,
} = modalSlice.actions;

export const modalSliceReducer = modalSlice.reducer;
